/** Modules */
import _ from "lodash";
import { getAIResponse } from "modules/Services";

export let cancelRequest;

export const generateAIResponse = ({ input, updatedSourceText = _.noop }) => {
  return async (dispatch, getState) => {
    try {
      let result;

      const response = await dispatch(
        getAIResponse({
          variables: {
            input,
          },
          getCancelToken: token => (cancelRequest = token),
          onDownloadProgress: async params => {
            const { content } = params;
            updatedSourceText({ value: content });

            result = {
              isSuccess: true,
              content,
            };
          },
        })
      );

      return response;
    } catch (err) {}
  };
};
